/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferConstructionSiteInfoRequest } from '../../models/offer-construction-site-info-request';

export interface UpdateOfferConstructionSiteInfo$Params {
  id: number;
      body: OfferConstructionSiteInfoRequest
}

export function updateOfferConstructionSiteInfo(http: HttpClient, rootUrl: string, params: UpdateOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateOfferConstructionSiteInfo.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateOfferConstructionSiteInfo.PATH = '/offers/{id}/construction-site-info';
